import { techstackImagesData } from "../data";
import TechStackCard from "../techstack-card";

/**
 * Renders a list of tech stack cards
 */
const TechStackList = () => {
  return (
    <div className="grid w-full grid-cols-2 px-10 md:grid-cols-4 md:px-5 xl:px-0">
      {techstackImagesData.map((i) => {
        return <TechStackCard key={i.id} data={i} />;
      })}
    </div>
  );
};

export default TechStackList;
